import { Directive, input, OnInit, Optional } from '@angular/core';
import { DataLayerService } from '../..';
import { EventNameKey, getEvent } from '../utils/event-name.mapper';
import { FormGroupDirective, NgForm } from '@angular/forms';
import { take, tap } from 'rxjs';

type EventType = 'click' | 'form-start';

@Directive({
	selector: '[ucNoPropsGAEvent]',
	standalone: true,
	host: {
		'(click)': 'onClick()',
	},
})
export class NoPropsGAEventDirective implements OnInit {
	event = input.required<EventNameKey>();
	eventType = input<EventType>('click');

	constructor(
		@Optional() private _ngForm: NgForm,
		@Optional() private _formGroupDir: FormGroupDirective,
		private _dataLayerSrv: DataLayerService,
	) {}

	ngOnInit(): void {
		if (this.eventType() === 'form-start') {
			this._initiateFormStartTracking();
		}
	}

	onClick() {
		if (this.eventType() !== 'click') return;

		this._dataLayerSrv.push({
			event: getEvent(this.event()),
			eventName: this.event(),
		});
	}

	private _initiateFormStartTracking() {
		const form = this._ngForm?.form || this._formGroupDir?.form;
		if (!form) {
			console.warn('No form found');
			return;
		}

		form.valueChanges
			.pipe(
				take(1),
				tap(() => {
					this._dataLayerSrv.push({
						event: getEvent(this.event()),
						eventName: this.event(),
					});
				}),
			)
			.subscribe();
	}
}
